import { request as baseRequest } from '@common/react/components/Api';
import { BaseParams } from '@common/react/objects/BaseParams';

import { ApplicationState } from '@app/store';
import { User } from '@app/objects/User';

export function request<T, D extends BaseParams = BaseParams>(type: string, data?: D, state?: ApplicationState, signal?: AbortSignal): Promise<T> {
	return baseRequest<T, User, ApplicationState>(type, data, state, signal);
}
